import CashbackPopupFrame from './CashbackPopupFrame';

export default CashbackPopupFrame;
